/* Shopify related recommendations replace collection fallback when available. */
(()=>{
  const init=(scope=document)=>{
    const sections=scope.querySelectorAll('[data-related-products]:not([data-related-initialized])');
    sections.forEach(section=>{
      section.dataset.relatedInitialized='true';
      const url=section.dataset.recommendationsUrl;
      if(!url)return;
      const load=async()=>{
        if(section.dataset.relatedLoaded==='true')return;
        section.dataset.relatedLoaded='true';
        try{
          const response=await fetch(url,{headers:{Accept:'text/html'}});
          if(!response.ok)return;
          const doc=new DOMParser().parseFromString(await response.text(),'text/html');
          const fresh=doc.querySelector('[data-related-products-grid][data-recommendations-available="true"]');
          const grid=section.querySelector('[data-related-products-grid]');
          if(fresh&&grid&&fresh.querySelector('.product-card')){
            grid.replaceChildren(...Array.from(fresh.children));
          }
        }catch(_error){
          /* Keep same-collection recommendations when the API is unavailable. */
        }
      };
      if(!('IntersectionObserver' in window)){load();return}
      const observer=new IntersectionObserver((entries,watch)=>{
        if(entries.some(entry=>entry.isIntersecting)){
          watch.disconnect();
          load();
        }
      },{rootMargin:'300px 0px'});
      observer.observe(section);
    });
  };
  init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
